const convertNumber = (val) => {
    const numberRegex = /^[0-9]*$/
    return numberRegex.test(val) ? Number(val) : 0
}

const takeNumberFromStr = (str) => {
    const regex = /[^\-\?0-9.]/ig
    const result = str.replace(regex, '')
    return Number(result)
}

const getYYMMDDHHMM = (timestamp) => {
    timestamp = Number(timestamp);
    let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y + M + D + h + m + s;
}

export {
    convertNumber,
    takeNumberFromStr,
    getYYMMDDHHMM,
}